import { getLocalStorage, saveLocalStorage } from "~services/utils/SaveIndexBD";

const checkStorageExistence = async ({ type = "limite-credito-offline" }) => {
  let obj = getLocalStorage(type, true);
  if(!obj) {
    saveLocalStorage(type, {}, true);
  }
}

export const setCustomLocalStorage = async ({ key, data = {}, type = "limite-credito-offline" }) => {
  await checkStorageExistence({});

  if(key) {
    const obj = getLocalStorage(type, true);

    if(!obj[key]) obj[key] = {};

    obj[key].dados = data;

    saveLocalStorage(type, obj, true);
  }
}

